import { PageHeader } from "@/components/shared/PageHeader";
import { NewActivityBar } from "@/components/shared/RowSignals";
import { DeliveryWorkspace } from "@/pages/SuperCrm";

// Every supervisor visit logged from Brugo Pro (supervisor_visits): selfie, photos, severity,
// remark, linked milestone and location check. Flagged visits also show in Customer Care.
export default function SiteVisits() {
  return (
    <div>
      <PageHeader title="Site Visits" subtitle="Every supervisor visit logged from Brugo Pro — selfie, photos, remark, severity, the milestone it checked and whether it was logged on site. Click any value to edit it; tick rows to bulk-update."
        actions={<NewActivityBar section="visits" />} />
      <DeliveryWorkspace tabs={["visits"]} section="visits" />
    </div>
  );
}
